import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {rolesApi} from '../http/Api';

export const getRoles = createAsyncThunk('Roles/getRoles', async (payload, thunkAPI) => {
  const {serverId} = thunkAPI.getState().serverId;
  const response = await rolesApi.getRoles(serverId);

  if (response.status === 200) {
    thunkAPI.dispatch(rolesSlice.actions.setRoles(response));
  }
});

const initialState = {
  rolesGlobalState: null,
};

const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    setRoles: (state, action) => {
      state.rolesGlobalState = action.payload;
    },
  },
});

export const roles = rolesSlice.reducer;
